export const blockIconsContentSaveAlt = (
	<span className='material-symbols-outlined'>save_alt</span>
);
